import { render, staticRenderFns } from "./ProductExplanation.vue?vue&type=template&id=04a883d8&scoped=true&"
import script from "./ProductExplanation.vue?vue&type=script&lang=ts&"
export * from "./ProductExplanation.vue?vue&type=script&lang=ts&"
import style0 from "./ProductExplanation.vue?vue&type=style&index=0&id=04a883d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a883d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VContainer,VImg,VRow,VSheet})
